import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

import TriathlonIndex from "./TriathlonIndex"

export default function TriGear() {

    return (
        <Container>
            <Row>
                <TriathlonIndex />
                <Col>
                    <h1>Gear Checklist</h1>
                    <p>Pack up the night before the race. As much as possible have the car ready to go. You will have to get up very early because you want to get there as early as possible to set up transition. Being ready to walk out the door will allow you to sleep as late as possible in the morning.</p>
                    <p>I use a checklist to make sure I remember everything. Below is a checklist of whatever I could imagine to get you thinking. Toss out what doesn't apply to your needs. But have a checklist and use it.</p>
                    <p>In the list below you'll see an item called "Large Colorful Towel." I place that on the ground underneath my gear. That makes it easy to spot my stuff. This is not that difficult for T1 because my bike is there and it's bright yellow and sticks out like a sore thumb. But for T2 you can't look for your bike. You've been riding it. It's in your hands. Plus the transition area will be starting to look it's been hit with a bomb. Things are scattered all over the place. I spot my towel, and I'm home free.</p>
                    <p>Something to Eat while Driving to Race<br></br>
                        Water for Drive to Race<br></br>
                        Race Drink for t minus 30 minutes<br></br>
                        Backpack for Gear<br></br>
                        Water Bottle <br></br>
                        Plastic Bags for getting into wet suit<br></br>
                        Large Colorful Towel <br></br>
                        Towel <br></br>
                        Watch <br></br>
                        Tri Suit <br></br>
                        Swim Cap <br></br>
                        Goggles <br></br>
                        Slippers <br></br>
                        Socks <br></br>
                        Number Holder and Number<br></br>
                        Bike Shoes<br></br>
                        Bike Gloves<br></br>
                        Bike Helmet<br></br>
                        Sun Glasses<br></br>
                        Bike <br></br>
                        Number for Bike<br></br>
                        Replacement Tire Tube and Changers<br></br>
                        Air Pump (for getting ready)<br></br>
                        Air Cartridge (for the race)<br></br>
                        Running Shoes <br></br>
                        Visor Running Hat<br></br>
                        Arm Sleeves (spf protection)<br></br>
                        Wet Suit <br></br>
                        Body Glide <br></br>
                        Suit Juice <br></br>
                        Goggle Anti-Fog <br></br>
                        USAT Card <br></br>
                        Maps - Registration Materials <br></br>
                        Caffeine Pills <br></br>
                        Clothes to change into afterwards<br></br>
                        Shampoo and Brush <br></br>
                        Food for after race<br></br>
                        Cooler with  Drink for after race<br></br>
                        Folding Camp Stool <br></br>
                        Kleenex<br></br>
                        Band Aids <br></br>
                        Tape <br></br>
                        Rubber Bands <br></br>
                        Markers <br></br>
                        Scissors <br></br>
                        Protein Bar <br></br>
                        Reading Material <br></br>
                        Sunscreen <br></br>
                        Warm Tech Shirt</p>
                </Col>
            </Row>

        </Container>
    )
}